export const BASE_URL = 'https://account-api.patna.ng/api/v1';
export const BASE_URL1 = 'https://asset-api.patna.ng/api';
export const TOKEN = 'hINpsFmjuIyiAWSTGUl5GdhqbeHGyZGNEzcyshUh';